const styles = {
  button: {
    minWidth: '120px'
  }
}

export default styles
